import '@/scripts/main';
import './theme.scss';
import '../../scripts/snippets/carousel.js';
import '../../scripts/snippets/product-tile.js';
import '../../scripts/snippets/recently-viewed.js';
import { initMinicart } from '@components/minicart';
import { initFirstWishlit } from '@components/wishlist';

(() => {
  initMinicart();
  initFirstWishlit();
})();
